import script from "./InfoPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoPanel.vue?vue&type=script&setup=true&lang=js"

import "./InfoPanel.vue?vue&type=style&index=0&id=5af0c166&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af0c166"]])

export default __exports__